/*
 * @Author: Fan
 * @Date: 2020-04-26 12:12:53
 * @description:
 * @LastEditors: Fan
 */
import baseAttribute from "../../src/common/component-base-attribute";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "dataItemName"],
        },
    },
    properties: {
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
    },
};
